import type * as api from '@gitbook/api-client';

import { useCurrentOrganization } from '../../state';

/**
 * Return the standalone merge rule for a given space.
 */
export function useSpaceMergeRules(space: api.Space): api.MergeRulesStandaloneConfiguration {
    const organization = useCurrentOrganization();
    const mergeRules =
        space.mergeRules.type === 'inherit' ? organization.mergeRules : space.mergeRules;

    return mergeRules;
}
